import en from './en'
import es from './es'
import cat from './cat'

export default { en, es, cat }